"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PxtTelemetryAssetIntegratedWebClient = void 0;
const DataPxtTelemetryEvents_1 = require("./DataPxtTelemetryEvents");
class PxtTelemetryAssetIntegratedWebClient {
    constructor(namespace, sendImperative, sendImperativeExplicitPath, collectPaths) {
        this.namespace = namespace;
        this.sendImperative = sendImperative;
        this.sendImperativeExplicitPath = sendImperativeExplicitPath;
        this.collectPaths = collectPaths;
    }
    describeEvents(...args) {
        const eventsWithTriggerResourceNames = typeof args[0] === "string"
            ? [
                {
                    triggerResourceNames: [args[0]],
                    events: args.slice(1),
                },
            ]
            : args;
        return new DataPxtTelemetryEvents_1.DataPxtTelemetryEvents(eventsWithTriggerResourceNames);
    }
    sendImperativeEventsExplicitPath(...events) {
        try {
            this.sendImperativeExplicitPath()(...events);
        }
        catch (e) {
            // TODO - capture error log
        }
    }
    sendImperativeEvents(...events) {
        try {
            this.sendImperative()(...events.map(({ event, metaPayload }) => ({
                event,
                metaPayload: {
                    namespacePath: [this.namespace],
                    ...metaPayload,
                },
            }), this));
        }
        catch (e) {
            // TODO - capture error log
        }
    }
    sendCriticalFeatureDuration(scopePath, durationMilliseconds) {
        try {
            this.sendImperativeEvents({
                event: {
                    resourceName: "arn:pxt:telemetry:event:core:timetocriticalfeature:1.0.0",
                    payload: {
                        durationMilliseconds,
                    },
                },
                metaPayload: {
                    scopePath: scopePath,
                },
            });
        }
        catch (e) {
            // TODO - capture error log
        }
    }
    reactPortalTelemetryCompatibilityPatch(element) {
        try {
            return {
                "data-pxt-telemetry-path": this.collectPaths()(element).getTelemetryPath(),
            };
        }
        catch (e) {
            // TODO - capture error log
            return {};
        }
    }
}
exports.PxtTelemetryAssetIntegratedWebClient = PxtTelemetryAssetIntegratedWebClient;
